import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Production } from '../components/Production';
import { Comparison } from '../components/Comparison';
import { Benefits } from '../components/Benefits';
import { Trust } from '../components/Trust';
import { FinalCTA } from '../components/FinalCTA';
import { QuoteForm } from '../components/QuoteForm';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-black overflow-x-hidden" data-id="element-172">
      <Header data-id="element-173" />
      <main data-id="element-174">
        <Hero data-id="element-175" />
        <SocialProof data-id="element-176" />
        <Production data-id="element-177" />
        <QuoteForm data-id="element-178" />
        <Comparison data-id="element-179" />
        <Benefits data-id="element-180" />
        <Trust data-id="element-181" />
        <FinalCTA data-id="element-182" />
      </main>
      <Footer data-id="element-183" />
    </div>;
}